<template>
  <div :class="cls">
    <div v-if="state.loading">
      <load-spinner></load-spinner>
    </div>
    <div v-if="state.location < 0.98 && player.currentTime > 1 && state.paused">
      <h2>{{ video.pagetitle }}</h2>
      <p class="time-to-end">זמן לסיום: {{ timeToEnd }}</p>
      <button class="yoga-btn" @click="resume">
        <div>המשך</div>
      </button>
    </div>

    <div v-if="state.location > 0.98" style="width:100%">
      <div class="next-videos" v-if="$route.params.sid">
        <h3 v-if="!isLast">כל הכבוד! סיימת עוד שיעור בתוכנית האימון שלך.</h3>
        <button class="yoga-btn" v-if="!isLast" @click="$emit('load-next')">
          המשך לשיעור הבא
        </button>

        <div v-else style="width: 100%;">
          <h3>כל הכבוד סיימת תוכנית אימון מלאה!</h3>
          <p>אנו גאים בך על ההתמדה.</p>
          <div v-if="nextSeries > 0">
            <p>אנחנו מזמינים אותך להמשיך ישר לתוכנית האימון</p>
            <gv-item :item="nextSeriesObj"></gv-item>
          </div>
          <router-link class="yoga-btn-beige" :to="{ name: 'series' }"
            >לרשימת כל תכניות האימון</router-link
          >
          <h4>שתף</h4>
          <a :href="video.shareUrl" target="_blank">
            <i class="mdi mdi-facebook blue" title="שיתוף בפייסבוק"></i>
          </a>
        </div>
      </div>
      <div v-else class="next-videos">
        <img src="../../assets/images/endIcon.png" alt="">
      
        <div v-if="!sending">
          <h3>כל הכבוד! סיימת שיעור נוסף ב - YogaNow</h3>
          <h4 class="is-hidden-mobile">התרגול שלך תורם גם לקהילה - יחד נגיע ליעד החודשי ונעניק מנויים למי שזקוקים לכך </h4>
          <div class="columns is-centered">
            <div>
              <h3>נהנת מהשיעור?</h3>
              <p>שלח\י למורה ברכת תודה</p>
              <button class="send-feedback" @click="sendFeedback">
               &#128591;
              </button>
            </div>
            <div class="is-hidden-mobile">
              <p>רוצה לחזור שוב לשיעור הזה בעתיד?</p>
              <p>לחיצה על הלב תשמור בשבילך את השיעור</p>
              <star-video :video="video"></star-video>
            </div>
          </div>
          
        </div>
        <div v-else>
          <div v-if="$store.state.teacherFeedback.showSpinner">
            <load-spinner></load-spinner>
          </div>
          <div v-else>
            <div v-if="$store.state.teacherFeedback.error">
              <h3 class="has-text-danger">אירעה שגיאה בנסיון השליחה</h3>
            </div>
            <div v-else>
              <h3 class="feedback-success">
                ה<i class="mdi mdi-heart"></i> נשלח
              </h3>
            </div>
          </div>
        </div>
        <!-- <h3 class="is-hidden-touch">שיעורי {{ current.label }} נוספים</h3>
        <videos
          :videos="moreVideos"
          class="is-hidden-touch next-videos"
        ></videos> -->
      </div>
    </div>
  </div>
</template>

<script>
import Videos from "@/components/Videos.vue";
import GvItem from "@/components/series/GvItem.vue";
import LoadSpinner from "@/components/LoadSpinner.vue";
import StarVideo from "@/components/video_page/StarVideo_v2.vue";

const shuffleArray = array => {
  // eslint-disable-next-line
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
  }
};

export default {
  name: `VideoOverlay`,
  props: {
    video: Object,
    state: Object,
    player: Object,
    isLast: {
      type: Boolean,
      default: false,
    },
    nextSeries: Number,
  },
  methods: {
    resume() {
      this.player.play();
    },
    sendFeedback() {
      this.$store.dispatch(`sendTeacherFeedback`, {
        videoId: this.video.id,
        teacherId: this.video.videoTeacher,
      });
    },
  },

  components: {
    Videos,
    GvItem,
    LoadSpinner,
    StarVideo
  },

  computed: {
    timeToEnd() {
      const secs = this.player.duration - this.player.currentTime;
      if (secs > 60) {
        return `${Math.floor(secs / 60)} דקות`;
      }
      return `${Math.floor(secs)} שניות`;
    },

    current() {
      if (this.$store.state.initialData.currents) {
        const arr = this.$store.state.initialData.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.video.current
          ) {
            return true;
          }
          return false;
        });
        return arr[0];
      }
      return {};
    },

    // moreVideos() {
    //   if (this.$store.state.videos) {
    //     const arr = this.$store.state.videos.filter(v => {
    //       if (
    //         typeof v.current !== `undefined` &&
    //         v.current === this.current.resource.id
    //       ) {
    //         return true;
    //       }
    //       return false;
    //     });
    //     shuffleArray(arr);
    //     return arr.slice(0, 3);
    //   }
    //   return [];
    // },

    nextSeriesObj() {
      if (this.nextSeries > 0) {
        const series = this.$store.state.series;
        // eslint-disable-next-line
        const arr = series.filter(
          // eslint-disable-next-line
          s => parseInt(s.id, 10) === this.nextSeries
          // eslint-disable-next-line
        );
        return arr[0];
      }
      return {};
    },

    sending() {
      return this.$store.state.teacherFeedback.sending;
    },
    cls() {
      if (this.player.paused && this.player.currentTime > 1) {
        if(this.state.location > 0.98){
          return "video-overlay is-overlay paused overlay-full";
        }
        return "video-overlay is-overlay paused";
      }
      return "video-overlay is-overlay";
    },
  },
};
</script>

<style lang="scss">
$overlayBg: #dedede;
$white: #ffffff;
$crimsonish: #976177;
$text: #191919;
$purple: #656b85;

.video-overlay {
  background-color: $overlayBg;
  padding: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  h2 {
    color: #000000;
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 5px;
  }

  .time-to-end {
    color: $purple;
    font-size: 16px;
    margin: 10px 0;
  }

  .yoga-btn {
    font-size: 1.5rem;
  }

  .next-videos {
    color: #000000;
    width: 100%;
    .mdi-facebook {
      font-size: 48px;
      background-color: $white;
    }

    h3 {
      font-size: 16px;
      font-weight: 900;
      color: #000000;
    }

    h4{
      font-weight: bold;
      font-size: 13px;;
    }

    p{
      font-size: 12px;
    }


    .is-half {
      width: 100%;
    }

    .columns {
      div{
        max-width: 280px;
        margin: 2rem auto;
      }
    }

    .like-btn {
      display: inline-block;
      padding-top: 10px;
      img {
        transform: scale(1.5);
      }
    }
    .group-video {
      p {
        display: none;
        color: #000000;
      }
      .s-current {
        display: none;
      }
      hr {
        display: none;
      }
    }

    hr {
      background-color: $purple;
      margin: 1rem auto;
      max-width: 200px;
    }

    .yoga-btn {
      margin-top: 1rem;
    }

    .next-videos {
      margin-top: 2rem;
      max-width: 1000px;
    }

    .feedback-success {
      color: #fd7170;
      font-size: 1.5rem;
    }
  }
  .video-item {
    max-width: 250px;
    h4 {
      color: $text;
      font-size: 0.9rem;
    }
    p,
    h5 {
      display: none;
    }
  }
}

.send-feedback{
  border: 0;
  background: transparent;
  font-size: 1.5rem;
}

.paused.video-overlay {
  left: auto;
}

.paused.overlay-full{
  left: 0;
}

.yoga-btn.resume-playing {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  .mdi {
    display: block;
    font-size: 1.5em;
    transform: rotateZ(180deg);
  }
}

.st1,
.st0 {
  fill: $purple;
}

@media screen and (min-width: 768px) {
  .video-overlay {
    h2 {
      font-size: 24px;
      margin-bottom: 20px;
    }
    .time-to-end {
      font-size: 24px;
      margin: 30px 0;
    }
    .next-videos{
      h3 {
        font-size: 21px;
      }

      h4{
        font-size: 16px;
      }
      p{
        font-size: 16px;
      }
      .columns{
        div{
          margin: 2rem;
        }
      }
    }
  }
}
</style>
